// https://developer.vimeo.com/api/guides/videos/upload
// SDKをロードします
let Vimeo = require('vimeo').Vimeo
export const vimeo = new Vimeo(
  "4ef4b72cc71e7669aec09e2de67fcf9ad10319a3",
  "03iRHBZm0xUsz3RmfaEBuDAovA18iJ4YykS2XmKATJ7l9qPtegWOgYd2B+/fiwBBIEKwCi+kYN0VpVc7E1CIsBYqCYdGcfYstGYc/ziBcRUVZQxvALBIG9dSp+VjkTOE",
  "344083d653292eb987f556ac147d5a82"
)